// extracted by mini-css-extract-plugin
module.exports = {"iconColor":"#e05d26"};